import React from 'react';
import PhoneInput from 'react-phone-input-2'
import ar from 'react-phone-input-2/lang/ar.json'
import 'react-phone-input-2/lib/style.css'
import './style.scss';


function PhoneInputComponent({ name, id, myplaceholder, myvalue, onValueChange, lang, disabled }) {

    return (
        <PhoneInput placeholder={myplaceholder}
                    withCountryCallingCode
                    country={"sa"}
                    localization={lang === 'ar' && ar}
                    preferredCountries={["sa", "eg", "us"]}
                    excludeCountries={["af"]}
                    value={myvalue}
                    onChange={(val) => onValueChange(val)}
                    autoFormat={false}
                    inputStyle={{
                        height: '45px',
                        borderRadius: '0px',
                        fontSize: '15px',
                        paddingLeft: '50px',
                        backgroundColor: '#fafafc',
                        color: '#888',
                        border: '1px solid #eee',
                        fontWeight: '400',
                        width: '95%',
                        marginLeft: '0px',
                    }}
                    buttonStyle={{
                        border: '1px solid #eee',
                        borderRadius: '0px',
                    }}
                    dropdownStyle={{
                        bottom: '100%',
                    }}
                    inputProps={{
                        id: id,
                        name: name,
                        required: true,
                        disabled: disabled || false,
                    }}
        />);
}

export default PhoneInputComponent
